module.exports = __webpack_public_path__ + "img/mini-landscape.b787c85.png";